import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Head from '../../components/Head'
import Modal from '../../components/modal/Modal'
import * as common from '../../common/commonFunction'
import commonSession from "../../common/commonSession"
import { useSpring, animated } from 'react-spring';
import { useEffect, useState } from 'react';
import $ from 'jquery';
import { isMobile } from "react-device-detect";
import moment from 'moment';
import {
    LOGIN_ALERT1, INVENTORY, SUMMARY, TITLE, MYMCUBE, CASH, WALLET, POM, COMMING_SOON, BALANCE, TICKET,
    TICKET_UNIT, MYMCARD, LEVEL, PURCHASE_HISTORY, SHARE, SETTING, EXPORT_COMMUNITY, BACK, PAY_STATUS, TICKET_TYPE
} from "../../lib/global_variable"

// Import Swiper React components
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import axios from 'axios'
import CouponModal from '../../components/modal/CouponModal'

// NFT page
const NFT = () => {

    var sessionInfo = commonSession.getSession()
    const auth = "Bearer " + sessionInfo.token;
    const rePayList = [];

    const [payList, setPayList] = useState([]); //all my pay list
    const [payListCnt, setPayListCnt] = useState(0); //all my pay list
    const [page, setPage] = useState(0); // pagination 추가 
    const [reload, setReload] = useState(false);

    // menu info
    const [pom, setPom] = useState(false)
    const [cash, setCash] = useState(false)
    const [nftCollection, setNftCollection] = useState(true)

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    const second = String(now.getSeconds()).padStart(2, '0');
    // const formattedDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    const formattedDateTime = now.toISOString().replace('Z', '');


    useEffect(() => {

        if (!sessionInfo.uid || sessionInfo.uid && sessionInfo.uid == '') {
            alert('로그인 후 이용해 주세요.');
            window.location.href = '/login?returnUrl=' + encodeURI(window.location.href);
            return false;
        }

        getPayList();

    }, [])

    useEffect(() => {

        if (!reload) {

            $.each(payList, async function (i, e) {

                const option2 = {
                    url: "/ticket?ticketId=" + e.ticketId,
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": auth
                    }
                }

                await axios(option2)
                    .then(async result => {
                        e.TicketData = result.data.data

                        if (e.fundingId) {
                            const option1 = {
                                url: "/funding?fundingId=" + e.fundingId,
                                method: 'GET',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json;charset=UTF-8',
                                    "Authorization": auth
                                }
                            }

                            await axios(option1)
                                .then(async res => {
                                    e.FundingData = res.data.data

                                    if (payList.length < payListCnt) {
                                        setPayList([...payList, e])
                                    }

                                })

                            if (payListCnt && i == (payListCnt - 1)) {
                                setReload(true)
                            }

                        } else {

                            if (payList.length < payListCnt) {
                                setPayList([...payList, e])
                            }

                            if (payListCnt && i == (payListCnt - 1)) {
                                setReload(true)
                            }
                        }

                    });
            })

        }

        console.log(payList);

    }, [payList])

    const changeTab = (e) => {

        switch (e.target.id) {
            case 'nftCollection': window.location.href = '/mypage/nftCllct'; break;
            case 'cash': break;
            default: window.location.href = '/wallet?type=POM'; break;
        }

    }

    // 상세 페이지 노출
    async function showDetail(id) {

        resetModal();
        await getItemInfo(id, 'detail');

    }

    function resetModal() {
        $('#modalPopup').find('.modal_body').html('');
    }

    function showModal(html) {
        $('#modalPopup').find('.modal_body').append(html);
        $('#modalPopup').show();
    }

    const getPayList = async () => {

        const option = {
            url: "/pay/all?pageSize=100&currentPage=" + page,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": auth
            }
        }

        axios(option)
            .then(async response => {
                console.log(response);
                if (response.status == 200) {
                    setPage(page + 1);
                    setPayList(response.data.data)
                    setPayListCnt(response.data.data.length)
                }
            });
    }

    // 구매상세 팝업 띄우기 
    function showViewData(item) {
        console.log(item);
        $('#viewModalPopup').css('display', 'block');
        $('#view-pay-id').val(item.payId);
        $('#view-pay-status').val(item.status);
        $('#pay-total-amount').html((item.totalAmount ?? 0));

        PAY_STATUS && PAY_STATUS.map((st, ind) => {
            if (item.status == st.code) {
                $('#pay-buy-badge').html(st.name);
            }
        })

        if (item.payType != "manual_transfer") {
            $('#pay-account-number').html('TOSS 결제<br/>환불은 신청 후 고객센터에 문의해주세요.');
        } else {
            $('#pay-account-number').html((item.FundingData ? item.FundingData.BankName : '가상은행') + '<br/>' + (item.FundingData ? item.FundingData.BankAccount : '000-0000-0000'));
        }

    }

    // 환불 및 구매신청 처리 
    function refundData() {
        var status = $('#view-pay-status').val();
        var refund_status = status == 'O1' ? 'CD' : (status == 'OD' ? 'R1' : '');

        if (refund_status != '') {
            $('#viewModalPopup').css('display', 'none');
            $('#refundModalPopup').css('display', 'block');
            $('#refund-pay-id').val($('#view-pay-id').val());
            $('#refund-pay-status').val(refund_status);
        } else {
            alert('구매 취소가 불가능한 상태입니다.');
            return false;
        }

    }

    //환불 신청 확정 처리 
    function submitRefund(e) {

        var idx = $('#refund-pay-id').val();
        var status = $('#refund-pay-status').val();


        var data = {
            status: status,
            payId: idx,
            ticketAmount: $('#TicketAmount_' + idx).val(),
            totalAmount: $('#TotalAmount_' + idx).val(),
            ticketCount: $('#TicketCount_' + idx).val(),
            ticketId: $('#TicketId_' + idx).val(),
            memberId: $('#MemberId_' + idx).val() ?? sessionInfo.uid,
        }

        const option = {
            url: "/refund/",
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": auth
            },
            data: data
        }

        // 결제상태 업데이트 처리 
        data = {
            status: status,
            payId: idx,
            fundingId: $('#FundingId_' + idx).val(),
            ticketAmount: Number($('#TicketAmount_' + idx).val()),
            totalAmount: Number($('#TotalAmount_' + idx).val()),
            ticketCount: Number($('#TicketCount_' + idx).val()),
            ticketId: $('#TicketId_' + idx).val(),
            memberId: $('#MemberId_' + idx).val() ?? sessionInfo.uid,
        }

        if ($('#CreatedAt_' + idx).val() && $('#CreatedAt_' + idx).val() != '') {
            data.createdAt = $('#CreatedAt_' + idx).val()
        }

        if ($('#UpdatedAt_' + idx).val() && $('#UpdatedAt_' + idx).val() != '') {
            data.updatedAt = $('#UpdatedAt_' + idx).val()
        }

        if ($('#DeletedAt_' + idx).val() && $('#DeletedAt_' + idx).val() != '') {
            data.deletedAt = $('#DeletedAt_' + idx).val()
        }

        if ($('#ConfirmationAt_' + idx).val() && $('#ConfirmationAt_' + idx).val() != '') {
            data.confirmationAt = $('#ConfirmationAt_' + idx).val()
        }

        axios(option)
            .then(response => {

                const option2 = {
                    url: "/pay?payId=" + idx,
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": auth
                    },
                    data: data
                }

                axios(option2)
                    .then(response => {
                        console.log(response);
                        showMailModal();
                        // window.location.reload();
                    }).catch(err => {
                        showMailModal();
                        $('#refundDoneModalPopup').find('.title').html("이미 티켓 구매 취소가<br>신청되었습니다.");
                    });
                // window.location.reload();
            });
    }

    const showMailModal = () => {
        $('#refundModalPopup').css('display', 'none')
        $('#refundDoneModalPopup').css('display', 'block');
    }

    // 쿠폰 등록 모달 띄우기 
    const showCouponModal = () => {
        $('#fundingModalPopup').css('display', 'block');
    }

    function dateFormat(date) {
        var date = new Date(date);

        let month = date.getMonth() + 1;
        let day = date.getDate();

        month = month >= 10 ? month : '0' + month;
        day = day >= 10 ? day : '0' + day;

        return date.getFullYear() + '.' + month + '.' + day + ' ';
    }

    function timeFormat(date) {
        var date = new Date(date);

        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();

        hour = hour >= 10 ? hour : '0' + hour;
        minute = minute >= 10 ? minute : '0' + minute;
        second = second >= 10 ? second : '0' + second;


        return hour + ':' + minute + ':' + second;
    }

    // 모바일에 따라 노출 처리 -- kjy
    if (isMobile) {

        return (
            <>
                <Head />
                <Header />
                <link rel='stylesheet' href='/css/mypage/nft.min.css' />
                <link rel='stylesheet' href='/css/modal/refund-modal.min.css' />
                <link rel='stylesheet' href='/css/modal/view-modal.min.css' />
                <div id="myNft" className="container w-100 text-center">
                    <content>
                        <div className="menu-tab-list">
                            <label htmlFor="nftCollection">
                                <input type="radio" name="wallet_tabs" id="nftCollection" onChange={changeTab} hidden />
                                {/* <img src="/img/renew-img/icon_bubble.svg" alt="speech-bubble" className="ready-speech-bubble"></img> */}
                                <span for="nftCollection">{MYMCUBE}</span>
                            </label>
                            <label htmlFor="cash">
                                <input type="radio" name="wallet_tabs" id="cash" onChange={changeTab} checked hidden />
                                <span for="cash" className="active">{CASH}</span>
                            </label>
                        </div>
                        <ul className="payList">
                            {payList && payList.map((item, index) => {
                                var createdAt = dateFormat(item.createdAt);
                                var timeAt = timeFormat(item.createdAt);

                                var cancelItem = "";

                                if (item.status == 'CD' || item.status == 'RD') {
                                    cancelItem = "line-through-deco";
                                }

                                return <li className={cancelItem}>
                                    <div className="list-box" data-idx={item.payId}>
                                        <input type="hidden" name="PayId[]" id={`PayId_` + item.payId} value={item.payId ?? ''} />
                                        <input type="hidden" name="FundingId[]" id={`FundingId_` + item.payId} value={item.fundingId ?? ''} />
                                        <input type="hidden" name="Status[]" id={`Status_` + item.payId} value={item.status ?? ''} />
                                        <input type="hidden" name="TotalAmount[]" id={`TotalAmount_` + item.payId} value={item.totalAmount ?? ''} />
                                        <input type="hidden" name="TicketAmount[]" id={`TicketAmount_` + item.payId} value={item.ticketAmount ?? ''} />
                                        <input type="hidden" name="TicketCount[]" id={`TicketCount_` + item.payId} value={item.ticketCount ?? ''} />
                                        <input type="hidden" name="TicketId[]" id={`TicketId_` + item.payId} value={item.ticketId ?? ''} />
                                        <input type="hidden" name="MemberId[]" id={`MemberId_` + item.payId} value={item.memberId ?? sessionInfo.uid} />
                                        <input type="hidden" name="ConfirmationAt[]" id={`ConfirmationAt_` + item.payId} value={item.confirmationAt ?? ''} />
                                        <input type="hidden" name="CreatedAt[]" id={`CreatedAt_` + item.payId} value={item.createdAt ?? ''} />
                                        <input type="hidden" name="UpdatedAt[]" id={`UpdatedAt_` + item.payId} value={item.updatedAt ?? ''} />
                                        <input type="hidden" name="DeletedAt[]" id={`DeletedAt_` + item.payId} value={item.deletedAt ?? ''} />
                                        <div className='d-flex align-items-start justify-content-between'>
                                                <img className='w-30' src={item.FundingData && item.FundingData.ThumbnailLink ?  item.FundingData.ThumbnailLink : "https://mymb-admin-media.s3.ap-northeast-2.amazonaws.com/events/1c49e115-3d71-4008-86d0-9048c8210a35.png"}></img>
                                            <div className="w-65">
                                                <div className='d-flex align-items-start justify-content-between'>
                                                    <p className="pay-status" onClick={() => showViewData(item)}>
                                                        {PAY_STATUS && PAY_STATUS.map((st, ind) => {
                                                            if (item.status == st.code) {
                                                                return st.name;
                                                            }
                                                        })}
                                                    </p>
                                                    <p className="pay-date" onClick={() => showViewData(item)}>{createdAt} {timeAt}</p>
                                                </div>
                                                <p className="funding-name" onClick={() => showViewData(item)}>{item.FundingData ? item.FundingData.SynopsisTitle : '웹툰제목'}</p>
                                                <p onClick={() => showViewData(item)}>{item.ticketAmount <= 100000 ? '퍼블릭 1차' : (item.ticketAmount <= 15000 ? '퍼블릭 2차' : '프리미엄')}</p>
                                                <div className="option-data d-flex align-items-start justify-content-between">
                                                    <span className="price-item" onClick={() => showViewData(item)}>티켓단가 : {item.ticketAmount ? Number(item.ticketAmount).toLocaleString() : 0} 원</span>
                                                    <span onClick={() => showViewData(item)}>수량 : {item.ticketCount ? Number(item.ticketCount).toLocaleString() : 0}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            })}
                        </ul>
                    </content>
                </div>
                <Modal />
                <CouponModal />
                {/* view-modal */}
                <div className="container w-100 text-center m-0">
                    <div className="modal" id="viewModalPopup">
                        <input type="hidden" name="view_pay_id" id="view-pay-id" value="" />
                        <input type="hidden" name="view_pay_status" id="view-pay-status" value="" />
                        <div className="modal_body w-80">
                            <p className="view-modal-title">구매상세</p>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="view-title">구매상태</p>
                                <p className="buy-badge" id="pay-buy-badge"></p>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="view-title">결제금액</p>
                                <p className="view-content"><span id="pay-total-amount"></span><span className='unit'>₩</span></p>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="view-title">입금계좌</p>
                                <p className="view-content" id="pay-account-number"></p>
                            </div>
                            <div className="btn-box">
                                <button type="button" className="primary-btn bg-normal" id="view-function" onClick={() => refundData()}>구매 취소</button>
                                <button type="button" className="primary-btn bg-primary" style={{ marginRight: "10px" }} onClick={() => $('#viewModalPopup').css('display', 'none')}>확인</button>
                            </div>
                        </div>
                    </div>
                </div >
                {/* refund-modal */}
                <div className="container w-100 text-center m-0">
                    <div className="modal" id="refundModalPopup">
                        <input type="hidden" name="refund_pay_id" id="refund-pay-id" value="" />
                        <input type="hidden" name="refund_pay_status" id="refund-pay-status" value="" />
                        <div className="modal_body w-80">
                            <p className="refund-modal-title">구매를 취소하시겠습니까?</p>
                            <div className="btn-box">
                                <button type="button" className="primary-btn bg-normal" id="refund-function" onClick={() => submitRefund(this)}>네</button>
                                <button type="button" className="primary-btn bg-primary" style={{ marginRight: "10px" }} onClick={() => $('#refundModalPopup').css('display', 'none')}>아니오</button>
                            </div>
                        </div>
                    </div>
                </div >
                <div className="container w-100 text-center m-0">
                    <div className="modal" id="refundDoneModalPopup">
                        <div className="modal_body w-80">
                            <p class="title">티켓 구매<br />취소가 신청 되었습니다.</p>
                            <div className="btn-box">
                                <button type="button" className="primary-btn bg-primary w-100" onClick={() => { $('#refundDoneModalPopup').css('display', 'none'); window.location.reload(); }}>확인</button>
                            </div>
                        </div>
                    </div>
                </div >
                <Footer />
            </>
        )
    } else {

        return (
            <>
                <Head />
                <Header />
                <link rel='stylesheet' href='/css/mypage/nft.min.css' />
                <link rel='stylesheet' href='/css/modal/refund-modal.min.css' />
                <link rel='stylesheet' href='/css/modal/view-modal.min.css' />
                <div id="myNft" className="container w-100 text-center">
                    <content>
                        <div className="mt-5 mb-5">
                            <div>
                                <div className="menu-tab-list d-flex align-items-center justify-content-center">
                                    <label htmlFor="nftCollection">
                                        <input type="radio" name="wallet_tabs" id="nftCollection" onChange={changeTab} hidden />
                                        {/* <img src="/img/renew-img/icon_bubble.svg" alt="speech-bubble" className="ready-speech-bubble"></img> */}
                                        <label htmlFor="nftCollection"><span>{MYMCUBE}</span></label>
                                    </label>
                                    <label htmlFor="nftCollection">
                                        <input type="radio" name="wallet_tabs" id="cash" onChange={changeTab} checked hidden />
                                        <label htmlFor="cash" className="active"><span>{CASH}</span></label>
                                    </label>
                                </div>
                                <ul className="payList">
                                    <li>
                                        <div><span>품목</span></div>
                                        <div><span>세일구분</span></div>
                                        <div><span>가격</span></div>
                                        <div><span>구매 갯수</span></div>
                                        <div><span>주문일시</span></div>
                                        <div><span>상태</span></div>
                                    </li>
                                    {payList && payList.map((item, index) => {
                                        var createdAt = dateFormat(item.createdAt);
                                        var timeAt = timeFormat(item.createdAt);
                                        var cancelItem = "";

                                        if (item.status == 'CD' || item.status == 'RD') {
                                            cancelItem = "line-through-deco";
                                        }

                                        return <li className={cancelItem}>
                                            <div className="list-box" data-idx={item.payId}>
                                                <input type="hidden" name="PayId[]" id={`PayId_` + item.payId} value={item.payId ?? ''} />
                                                <input type="hidden" name="FundingId[]" id={`FundingId_` + item.payId} value={item.fundingId ?? ''} />
                                                <input type="hidden" name="Status[]" id={`Status_` + item.payId} value={item.status ?? ''} />
                                                <input type="hidden" name="TotalAmount[]" id={`TotalAmount_` + item.payId} value={item.totalAmount ?? ''} />
                                                <input type="hidden" name="TicketAmount[]" id={`TicketAmount_` + item.payId} value={item.ticketAmount ?? ''} />
                                                <input type="hidden" name="TicketCount[]" id={`TicketCount_` + item.payId} value={item.ticketCount ?? ''} />
                                                <input type="hidden" name="TicketId[]" id={`TicketId_` + item.payId} value={item.ticketId ?? ''} />
                                                <input type="hidden" name="MemberId[]" id={`MemberId_` + item.payId} value={item.memberId ?? sessionInfo.uid} />
                                                <input type="hidden" name="ConfirmationAt[]" id={`ConfirmationAt_` + item.payId} value={item.confirmationAt ?? ''} />
                                                <input type="hidden" name="CreatedAt[]" id={`CreatedAt_` + item.payId} value={item.createdAt ?? ''} />
                                                <input type="hidden" name="UpdatedAt[]" id={`UpdatedAt_` + item.payId} value={item.updatedAt ?? ''} />
                                                <input type="hidden" name="DeletedAt[]" id={`DeletedAt_` + item.payId} value={item.deletedAt ?? ''} />
                                                <span className="w-22" onClick={() => showViewData(item)}>{item.FundingData ? item.FundingData.SynopsisTitle : '웹툰제목'}</span>
                                                <span onClick={() => showViewData(item)}>{item.ticketAmount <= 100000 ? '퍼블릭 1차' : (item.ticketAmount <= 150000 ? '퍼블릭 2차' : '프리미엄')}</span>
                                                <span className="price-item" onClick={() => showViewData(item)}>{item.ticketAmount ?? 0}</span>
                                                <span className="w-22" onClick={() => showViewData(item)}>{item.ticketCount ?? 0}</span>
                                                <span className="w-22" onClick={() => showViewData(item)}>{createdAt}<br />{timeAt}</span>
                                                <span onClick={() => showViewData(item)}>
                                                    {PAY_STATUS && PAY_STATUS.map((st, ind) => {
                                                        if (item.status == st.code) {
                                                            return st.name;
                                                        }
                                                    })}
                                                </span>
                                            </div>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </content >
                </div >
                <Modal />
                <CouponModal />
                {/* view-modal */}
                <div className="container w-100 text-center m-0">
                    <div className="modal" id="viewModalPopup">
                        <input type="hidden" name="view_pay_id" id="view-pay-id" value="" />
                        <input type="hidden" name="view_pay_status" id="view-pay-status" value="" />
                        <div className="modal_body w-80">
                            <p className="view-modal-title">구매상세</p>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="view-title">구매상태</p>
                                <p className="buy-badge" id="pay-buy-badge"></p>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="view-title">결제금액</p>
                                <p className="view-content"><span id="pay-total-amount"></span><span className='unit'>₩</span></p>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="view-title">입금계좌</p>
                                <p className="view-content" id="pay-account-number"></p>
                            </div>
                            <div className="btn-box">
                                <button type="button" className="primary-btn bg-normal" id="view-function" onClick={() => refundData()}>구매 취소</button>
                                <button type="button" className="primary-btn bg-primary" style={{ marginRight: "10px" }} onClick={() => $('#viewModalPopup').css('display', 'none')}>확인</button>
                            </div>
                        </div>
                    </div>
                </div >
                {/* refund-modal */}
                <div className="container w-100 text-center m-0">
                    <div className="modal" id="refundModalPopup">
                        <input type="hidden" name="refund_pay_id" id="refund-pay-id" value="" />
                        <input type="hidden" name="refund_pay_status" id="refund-pay-status" value="" />
                        <div className="modal_body w-80">
                            <p className="refund-modal-title">구매를 취소하시겠습니까?</p>
                            <div className="btn-box">
                                <button type="button" className="primary-btn bg-normal" id="refund-function" onClick={() => submitRefund(this)}>네</button>
                                <button type="button" className="primary-btn bg-primary" style={{ marginRight: "10px" }} onClick={() => $('#refundModalPopup').css('display', 'none')}>아니오</button>
                            </div>
                        </div>
                    </div>
                </div >
                <div className="container w-100 text-center m-0">
                    <div className="modal" id="refundDoneModalPopup">
                        <div className="modal_body w-80">
                            <p class="title">티켓 구매<br />취소가 신청 되었습니다.</p>
                            <p class="content">*계좌 확인 안내 메일이 발송될 예정입니다.</p>
                            <div className="btn-box">
                                <button type="button" className="primary-btn bg-primary w-100" onClick={() => { $('#refundDoneModalPopup').css('display', 'none'); window.location.reload(); }}>확인</button>
                            </div>
                        </div>
                    </div>
                </div >
                <Footer />
            </>
        )
    }
}
export default NFT;